import axiosInstance from 'utils/axios';

export const loginSuccess = (email) => {
  axiosInstance.get('auth/track-login', {
    email,
  });
};
